import { TakerMarket } from '@/enterprise/data/useTakerMarkets';

const getRenewalSchedule = (takerMarket: TakerMarket) => {
  const hasRenewalSchedule: boolean = !!takerMarket.offerSchedule && takerMarket.offerSchedule.type === 'renewal';
  const renewalIntervalDays: number | undefined =
    (hasRenewalSchedule &&
      'renewalIntervalDays' in takerMarket.offerSchedule!.schedule &&
      takerMarket.offerSchedule!.schedule.renewalIntervalDays) ||
    undefined;

  return { hasRenewalSchedule, renewalIntervalDays };
};

export default getRenewalSchedule;
